// @ts-nocheck
import _ from 'lodash-es';
import angular from 'angular';
import templateModalConfirmUpdate from '~/components/oo-admin/modal/modal-confirm-update.html';
import APIV5 from '~/models/api';
import ModalConfirmUpdateController from '~/components/oo-admin/modal/modal-confirm-update.controller';
import {
	COMPONENT_OF, COMPOSED_OF, DEFINED_BY, ELEMENT_OF, INHERITS, LIKE,
} from '../../constants/common-kids';
import Form from './form';
import Link from './link';
import Node from './node';
import Repre from './repre';

/* globals Knitiv */

const isMultipleSameDicoEntries = dicoObject => {
	if (!dicoObject) {
		return false;
	}

	const dicoValues = Object.values(dicoObject);
	const result = _.uniqWith(
		dicoValues, (a, b) => a.objnum2_kid === b.objnum2_kid
			&& a.relation_kid === b.relation_kid
			&& a.linker_kid === b.linker_kid,
	);

	// If the length are not the same
	// That means that some entries are filtered, so are duplicates
	return result.length !== dicoValues.length;
};

const isMultipleSameCommonEntries = common => {
	if (!common) {
		return false;
	}

	const commonValues = Object.values(common);
	const result = _.uniqWith(commonValues, (a, b) => a.dico_id === b.dico_id);

	// If the length are not the same
	// That means that some entries are filtered, so are duplicates
	return result.length !== commonValues.length;
};

const ignoreRelations = new Set([
	COMPOSED_OF,
	ELEMENT_OF,
]);

export class NodeService {
	#$injector;

	/** @type {Knitiv.Angular.Q} */
	#$q;

	#$rootScope;

	/** @type {Knitiv.Angular.ModalService} */
	#$uibModal;

	#rootNode;

	/** @type {Knitiv.UserModel} */
	User;

	/* @ngInject */
	constructor($injector) {
		this.#$injector = $injector;
		this.#$q = this.#$injector.get('$q');
		this.#$rootScope = this.#$injector.get('$rootScope');
		this.#$uibModal = this.#$injector.get('$uibModal');
		this.Notification = this.#$injector.get('Notification');
		this.User = this.#$injector.get('User');

		this.#rootNode = [];
	}

	// eslint-disable-next-line no-undef
	#recurse(item, nodes) {
		for (const node of nodes) {
			if (node.kid) {
				item.OBJECT_LIST[node.kid] = _.merge(node.getOrder(), { isa: node.isa.objid });
			}
			this.#recurse(item, node.nodes);
		}
	}

	#setRootNode(node) {
		for (const n of node.nodes) {
			this.#setRootNode(n);
		}

		if (((node.parent && !node.parent.hasChanged()) || !node.parent) && node.hasChanged()) {
			this.#rootNode.push(node);
			if (node.parent) {
				node.parent.nodes.length = 0;
			}
		}
	}

	/**
	 * Create a virtual node
	 * If no kid specified, generate one
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} isa - The class type of the node
	 * @param {import('@knitiv/api-client-javascript').KNodeOptional | string} [kid]
	 * @returns {Node} Created node instance
	 */
	create(isa, kid) {
		const node = new Node(this.#$injector, kid || `K_NODE;${this.User.getRefNr()}`, isa);
		// noinspection JSValidateTypes
		node.kid = kid || `K_NODE;${this.User.getRefNr()}`;
		node.kndef.id = node.kid.split(';')[1];
		node.kndefext.id = node.kndef.id;
		node.setIsa(isa);
		node.create = true;
		node.objtype = isa === 'K_NODE;SYS_CLASSE' ? 'CLASS' : 'OBJECT';
		node.owner.kid = this.#$rootScope.context.profil.kid;
		node.owner.name = this.#$rootScope.context.profil.name;

		return node;
	}

	// res=data.objectinfo
	createForm(result) {
		if (result) {
			const form = this.loadRes(result, true, true);
			form.create = true;
			return form;
		}
		return new Form(this.#$injector);
	}

	delete(kid) {
		return APIV5.instance.objectDelete({ items: kid }, { id: 'node-service.delete' });
	}

	detachFile(objid) {
		return APIV5.instance.objectDetachFile({ objid }, { id: 'node-service.detach-file' });
	}

	async download(objid, name) {
		const result = await APIV5.instance.objectExportJSON({ objid }, { id: 'node-service.download' });
		const a = document.createElement('a');
		a.href = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(result.value))}`;
		a.download = `${name || objid}.json`;
		document.body.append(a);
		a.click();
		a.remove();
		return true;
	}

	async duplicate(node) {
		const objectList = {};

		objectList[node.kid] = node.getOrder();

		await APIV5.instance.objectDuplicate({
			items: [
				{
					target_objnum: node.kid,
					OBJECT_LIST:   objectList,
				},
			],
		}, { id: 'node-service.duplicate' });
		node.setOrder({});
	}

	/**
	 * @returns {import('@knitiv/api-client-javascript').KNode[]}
	 */
	dynRelations() {
		return [
			DEFINED_BY,
			COMPONENT_OF,
			INHERITS,
			LIKE,
		];
	}

	async exists(isa) {
		return APIV5.instance.objectExist({ isa }, { id: 'node-service.exists' });
	}

	/**
	 * Get a node attribute by name
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {Promise<any>}
	 */
	async get(kid) {
		const r = await APIV5.instance.get({ elt_kid: kid }, { id: 'node-service.get' });
		return kid in r ? r[kid] : undefined;
	}

	/**
	 * @param {
	 *   import('@knitiv/api-client-javascript').ObjectInfoOutput
	 *   | import('@knitiv/api-client-javascript').ObjectDefOutput
	 * } result
	 * @param {boolean} form
	 * @param {boolean} definition
	 * @param {boolean} admin
	 * @param {boolean} droit
	 * @returns {Form|Node}
	 *
	 * res contient data.objectinfo
	 */
	loadRes(result, form = false, definition = false, admin = false, droit = true) {
		const node = form ? new Form(this.#$injector) : new Node(this.#$injector, result.objid, result.isa.objid);
		node.set(result, definition, admin, droit);

		return node;
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} classKid
	 * @param {any} condition
	 * @param {import('@knitiv/api-client-javascript').PacketInfo} [options]
	 * @returns {Promise<Node[]>}
	 */
	async list(classKid, condition, options = null) {
		const result = await APIV5.instance.objectList({ classKid, condition, options }, { id: 'node-service.list' });

		/** @type {Node[]} */
		const nodes = [];
		for (const [kid, n] of Object.entries(result.list)) {
			const node = new Node(this.#$injector, kid, n.isa);
			node.icon = n.icon;
			node.kjson = n.kjson;

			if (n.link_list) {
				for (const [flow, gl] of Object.entries(n.link_list)) {
					for (const [relationKid, l2] of Object.entries(gl)) {
						if (relationKid !== DEFINED_BY && relationKid !== COMPONENT_OF) {
							node.link.push(...Object.entries(l2.list).map(([linkKid, link]) => new Link({
								...link,
								kid:          linkKid,
								flow,
								relation_kid: relationKid,
							})));
						}
					}
				}
			}

			if (n.repre_all) {
				for (const [repreKid, r] of Object.entries(n.repre_all)) {
					node.addRepre(new Repre({
						lang: {
							kid: repreKid,
							isa: r.lang_isa,
						},
						value: r.name,
					}));
				}

				// @ts-ignore
				node.isfile = n.isfile === 1;
				// @ts-ignore
				node.wf = n.wf;

				nodes.push(node);
			}
		}
		return nodes;
	}

	/**
	 * Query infos on an object
	 *
	 * @param {string} kid - The ID of the object to query
	 * @param {string[]} [get] - What infos to include
	 * @param {string} [origin] - The origin of the request
	 * @param {string[]} [nget] - What infos to exclude
	 * @param {string} id
	 * @returns {Promise<Node | Form | undefined>} Promise result
	 */
	async load(kid, get, origin, nget, id = 'node-service.load') {
		if (!kid || kid === '0') {
			return undefined;
		}
		let result;
		try {
			const node = await APIV5.instance.objectInfo(
				{
					kid,
					get,
					origin,
					nget,
				},
				{
					id,
				},
				{},
			);
			result = this.loadRes(node);
		}
		catch {
			result = null;
		}
		return result;
	}

	async loadAdmin(kid) {
		const result = await APIV5.instance.objectInfo(
			{
				kid,
				get: ['ALL'],
				nget: ['object'],
				origin: 'NORMAL',
			},
			{
				id: 'node-service.load-admin',
			},
		);
		return result ? this.loadRes(result, true, false, true) : null;
	}

	/**
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} isa
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @param {any} options
	 * @returns {Promise<Form|Node|null>}
	 */
	async loadDef(isa, kid = null, options = {}) {
		const result = await APIV5.instance.objectDef({ isa, kid, params: options }, { id: 'node-service.load-def' });
		return result ? this.loadRes(result, false, true, false) : null;
	}

	lock(node) {
		return APIV5.instance.nodeLock(node.kid, { id: 'node-service.lock' });
	}

	lockInfo(node) {
		return APIV5.instance.nodeLockInfo(node.kid, { id: 'node-service.lock-info' });
	}

	/**
	 * @param {Node | Form} node
	 * @param {'AllObjectOfClass' | 'AllInherits' | 'AllObjectOfClassInherits' | 'self'} mode
	 * @returns {Promise<any>}
	 */
	async permissionPopulate(node, mode) {
		const populate = await APIV5.instance.permissionPopulate(
			{ mode, objid: node.kid },
			{ id: 'oo-admin.permission-populate' },
		);
		return populate;
	}

	/**
	 * Reset node
	 *
	 * @param {Node | Form} node Node instance
	 */
	reset(node) {
		node.reset();
		this.#rootNode.length = 0;
	}

	/**
	 * Update or create nodes (by calling ObjectSet)
	 *
	 * @param {Node[]} nodes Node instance to update
	 * @param {boolean} showConfirmationModal
	 * @param {'YES' | 'NO' | undefined} [droitForce]
	 * @param {'YES' | 'NO' | undefined} [droitDefForce]
	 * @returns {Promise} Promise result
	 */
	// eslint-disable-next-line unicorn/prevent-abbreviations
	async set(nodes, showConfirmationModal = false, droitForce = undefined, droitDefForce = undefined) {
		const items = [];

		// items2 is only used in show confirmation modal
		const items2 = [];

		for (const node of nodes) {
			const objectList = {
				[node.kid]: {
					isa:           node.isa.objid,
					type_kid:      node.type_kid,
					ATTRIBUT_LIST:  [],
					DROIT_LIST:     [],
					DROITCUST_LIST: [],
					DROITDEF_LIST:  [],
					LINK_LIST:      {},
					REPRE_LIST:     [],
				},
			};

			if (droitForce !== undefined) {
				// eslint-disable-next-line no-underscore-dangle
				objectList[node.kid]._droit_force_ = droitForce;
			}

			if (droitDefForce !== undefined) {
				// eslint-disable-next-line no-underscore-dangle
				objectList[node.kid]._droitdef_force_ = droitDefForce;
			}

			for (const attribut of node.attribut) {
				const order = {
					name:     attribut.name,
					ref_type: attribut.ref_type,
				};

				if (attribut.ref_type === 'KEPLER_TYPE;TEXT') {
					order.data1 = attribut.value ?? '';
				}
				else if (attribut.ref_type === 'KEPLER_TYPE;JSON') {
					order.data1 = angular.toJson(attribut.value);
				}
				else {
					order.value = attribut.value;
				}
				objectList[node.kid].ATTRIBUT_LIST.push(order);
			}

			for (const droit of node.droit) {
				objectList[node.kid].DROIT_LIST.push({
					kright:   droit.kright,
					org_kid:  droit.org.kid,
					role_kid: droit.role.kid,
				});
			}

			for (const droitcust of node.droitcust) {
				objectList[node.kid].DROITCUST_LIST.push(droitcust.export());
			}

			for (const droitdef of node.droitdef) {
				objectList[node.kid].DROITDEF_LIST.push(droitdef.export());
			}

			for (const link of node.link) {
				if (link.flow === 'from' && ignoreRelations.has(link.relation_kid)) {
					if (!(link.relation_kid in objectList[node.kid].LINK_LIST)) {
						objectList[node.kid].LINK_LIST[link.relation_kid] = [];
					}
					objectList[node.kid].LINK_LIST[link.relation_kid].push({
						class_kid:    link.class_kid,
						linker_kid:   link.linker_kid,
						objnum2:      link.objnum2_kid,
						objnum2_isa:  link.isa,
						relation_kid: link.relation_kid,
					});
				}
			}

			objectList[node.kid].REPRE_LIST = node.repre.map(repre => repre.exportForObjectSet());

			// Deletion
			const pOrder = node.getOrder();
			['ATTRIBUT_LIST', 'DROIT_LIST', 'DROITCUST_LIST', 'DROITDEF_LIST', 'REPRE_LIST'].map(type => {
				if (pOrder[type]) {
					pOrder[type].filter(item => item.action === 'DEL').map(item => {
						objectList[node.kid][type].push(item);
						return item;
					});
				}
				return type;
			});

			if (pOrder.LINK_LIST) {
				for (const [relationKid, link] of Object.entries(pOrder.LINK_LIST)) {
					for (const item of link.filter(l => l.action === 'DEL')) {
						if (objectList[node.kid].LINK_LIST === undefined) {
							objectList[node.kid].LINK_LIST = {};
						}
						if (!Array.isArray(objectList[node.kid].LINK_LIST[relationKid])) {
							objectList[node.kid].LINK_LIST[relationKid] = [];
						}
						objectList[node.kid].LINK_LIST[relationKid].push(item);
					}
				}
			}

			objectList[node.kid].kjson = node.kjson ? angular.toJson(node.kjson) : null;
			objectList[node.kid].kndef = node.kndef;
			objectList[node.kid].kndefext = node.kndefext;

			items.push({
				target_objnum: node.kid,
				OBJECT_LIST:   objectList,
			});

			if (showConfirmationModal) {
				const objectList2 = node.makeObject(false, node.kid);
				// eslint-disable-next-line no-underscore-dangle
				if (objectList[node.kid]._droit_force_ !== undefined) {
					// eslint-disable-next-line no-underscore-dangle
					objectList2[node.kid]._droit_force_ = objectList[node.kid]._droit_force_;
				}
				// eslint-disable-next-line no-underscore-dangle
				if (objectList[node.kid]._droitdef_force_ !== undefined) {
					// eslint-disable-next-line no-underscore-dangle
					objectList2[node.kid]._droitdef_force_ = objectList[node.kid]._droitdef_force_;
				}
				const item2 = {
					target_objnum: node.kid,
					OBJECT_LIST:   objectList2,
				};
				this.#recurse(item2, node.nodes);
				items2.push(item2);
			}
		}

		if (items.length === 0) {
			throw new Error('Empty items!');
		}

		try {
			if (showConfirmationModal) {
				await this.#$uibModal.open({
					template:     templateModalConfirmUpdate,
					controller:   ModalConfirmUpdateController,
					controllerAs: '$ctrl',
					resolve:      {
						items: () => items2,
					},
				}).result;
			}
			const result = await APIV5.instance.objectSet({ items }, { id: 'node-service.set' });
			nodes.map(node => this.reset(node));
			return this.#$q.when(result);
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
			for (const node of nodes) {
				this.reset(node);
			}
			return this.#$q.reject(error);
		}
	}

	unlock(node) {
		return APIV5.instance.nodeUnlock(node.kid, { id: 'node-service.unlock' });
	}

	/**
	 * Update or create a node
	 *
	 * @param {Node | Form} node Node instance to update
	 * @param {boolean} [showConfirmationModal] show list changes before confirmation
	 * @returns {Promise<any>} Promise result
	 */
	async update(node, showConfirmationModal = false) {
		let result = false;
		this.#setRootNode(node);

		for (const ktype of ['kndef', 'kndefext']) {
			if (
				node[ktype].CLASS.COMMON
				&& !Array.isArray(node[ktype].CLASS.COMMON)
				&& typeof node[ktype].CLASS.COMMON === 'object'
			) {
				node[ktype].CLASS.COMMON = Object.values(node[ktype].CLASS.COMMON);
			}

			if (isMultipleSameDicoEntries(node[ktype].CLASS.DICO)) {
				const error = 'Impossible de sauvegarder DICO: des entrées sont en double';
				this.Notification.error({
					title:   'Entrée existante !',
					message: error,
				});
				throw new Error(error);
			}

			if (isMultipleSameCommonEntries(node[ktype].CLASS.COMMON)) {
				const error = 'Impossible de sauvegarder COMMON: des entrées sont en double';
				this.Notification.error({
					title:   'Entrée existante !',
					message: error,
				});
				throw new Error(error);
			}
		}

		const items = [];
		let create = false;
		let item;

		for (const rootNode of this.#rootNode) {
			const objectList = rootNode.makeObject(create, node.kid);

			if (rootNode.kid.startsWith('K_NODE;_NR_') || rootNode.create) {
				create = true;
			}

			item = {
				target_objnum: rootNode.kid,
				OBJECT_LIST:   objectList,
			};
			this.#recurse(item, rootNode.nodes);
			items.push(item);
		}

		if (create && items.length > 0) {
			try {
				result = await APIV5.instance.objectCreate({ items }, { id: 'node-service.update' });
				if (result) {
					this.reset(node);
				}
			}
			catch {
				this.reset(node);
			}
			return result;
		}

		if (items.length === 0) {
			throw new Error('Empty items!');
		}

		try {
			if (showConfirmationModal) {
				await this.#$uibModal.open({
					template:     templateModalConfirmUpdate,
					controller:   ModalConfirmUpdateController,
					controllerAs: '$ctrl',
					resolve:      {
						items: () => items,
					},
				}).result;
			}
			result = await APIV5.instance.objectModify({ items }, { id: 'node-service.update' });
			this.reset(node);
		}
		catch (error) {
			// reset root node on modal close
			// root node take an array of the changes
			this.#rootNode.length = 0;
			if (error !== 'cancel') {
				console.error(error);
			}
		}

		return result;
	}

	/**
	 * Update or create multiple nodes
	 *
	 * @param {Node[]} nodes Array of nodes instance to update
	 * @returns {Promise} Promise result
	 */
	async updateMultiple(nodes) {
		const items = [];
		let create = false;

		for (const node of nodes) {
			if (
				node.kndef.CLASS.COMMON
				&& !Array.isArray(node.kndef.CLASS.COMMON)
				&& typeof node.kndef.CLASS.COMMON === 'object'
			) {
				node.kndef.CLASS.COMMON = Object.values(node.kndef.CLASS.COMMON);
			}

			if (
				node.kndefext.CLASS.COMMON
				&& !Array.isArray(node.kndefext.CLASS.COMMON)
				&& typeof node.kndefext.CLASS.COMMON === 'object'
			) {
				node.kndefext.CLASS.COMMON = Object.values(node.kndefext.CLASS.COMMON);
			}

			const objectList = node.makeObject(create, node.kid);

			if (!node.parent && (node.kid.startsWith('K_NODE;_NR_') || node.create)) {
				create = true;
			}

			const item = {
				target_objnum: node.kid,
				OBJECT_LIST:   objectList,
			};
			this.#recurse(item, node.nodes);
			items.push(item);
		}

		if (items.length === 0) {
			throw new Error('Empty items!');
		}

		try {
			const result = await APIV5.instance.objectSet({ items }, { id: 'node-service.update-multiple' });
			nodes.map(node => this.reset(node));
			return this.#$q.when(result);
		}
		catch (error) {
			nodes.map(node => {
				const oldCreate = node.create;
				this.reset(node);
				node.create = oldCreate;
				return node;
			});
			return this.#$q.reject(error);
		}
	}
}
